module.exports = __webpack_public_path__ + "img/zhys_zhCn.7eed6254.png";